(function () {
	'use strict';

	angular.module('qbePortal').controller('QBParentClass', QBParentClass);

	QBParentClass.$inject = ['$scope'];

	function QBParentClass($scope) {
		var vm = this;
	}

	angular.module('qbePortal').directive('qbParentClass', [
		function () {
			return {
				restrict: 'A',
				controller: QBParentClass,
				controllerAs: 'vm',
				scope: {
					qbParentClass: '<',
					qbParentElement: '@?'
				},
				link: function (scope, element, attrs, ctrl) {

					scope.$watch(function () {
						var classes = $(element).find('input').attr('class');
						return classes;
					}, function (newValue, oldValue) {
						if (!newValue) return;
						if (newValue.indexOf('ng-invalid') >= 0)
							console.log('field is invalid');
						else
							console.log('field is valid.')


					});


					// for (var cssClass in scope.qbParentClass ) {
					// 	var condition = scope.qbParentClass[cssClass] ;
					// 	var parent = scope.qbParentElement ? element.parents(scope.qbParentElement) : element.parent() ;
					// 	if (condition)
					// 		parent.addClass(cssClass);
					// 	else
					// 		parent.removeClass(cssClass) ;
					// }


				}
			};
		}]);
})();
